<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">查看答卷</p>
      <div class="options">
        <Button type="ghost" icon="ios-undo" @click="back">返回</Button>
      </div>
      <div class="content">
        <div class="content-message">
          <h3 class="content-title">答题信息</h3>
          <Row class="row">
            <Col span="6">
              <span>答题序号：</span>
              <span>{{index + 1}}</span>
            </Col>
            <Col span="6">
              <span>答题状态：</span>
              <span>{{form.state === 1? '已回答' : ''}}</span>
            </Col>
            <Col span="6">
              <span>开始时间：</span>
              <span>{{form.start_time}}</span>
            </Col>
            <Col span="6">
              <span>结束时间：</span>
              <span>{{form.end_time}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="6">
              <span>答题时长：</span>
              <span>{{this.second(form.time_cost)}}</span>
            </Col>
            <Col span="6">
              <span>浏览器：</span>
              <span>{{form.browser}}</span>
            </Col>
            <Col span="6">
              <span>操作系统：</span>
              <span>{{form.operating_system}}</span>
            </Col>
            <Col span="6">
              <span>用 户 IP：</span>
              <span>{{form.ip}}</span>
            </Col>
          </Row>
        </div>
        <div class="content-message">
          <h3 class="content-title">答题详情</h3>
          <Row v-for="(item, index) in form.surveyAnswerNodes" :key="index" class="rowList" :style="{ borderBottom: index === (form.surveyAnswerNodes.length - 1)? '1px solid #dfdfdf' : ''}">
            <Col span="24">
              <p style="font-size: 14px; color: #333; font-weight: 600;">
                Q{{index + 1}}：
                {{item.tfname}}
                [
                {{
                item.tftype === 1? '单选框':
                item.tftype === 2? '多选题':
                item.tftype === 3? '填空题':
                item.tftype === 4? '下拉题':
                item.tftype === 5? '标题':
                item.tftype === 6? '分割线':
                item.tftype === 7? '说明文本':
                item.tftype === 8? '评分':
                item.tftype === 9? '横向填空':'表格'
                }}
                ]
              </p>
              <p v-html="item.infeedFillBlankText" v-if="item.tftype === 9"></p>
              <p v-for="(ele, index2) in item.fvs" :key="index2" v-else>{{ele.name? (ele.name + ':'):'' }} {{ele.value}}</p>
            </Col>
          </Row>
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: '',
      index: '',
      form: {},
      // infeedFillBlankText: '',
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.index = this.$route.query.index
    this.getDetails()
  },
  computed() {},
  methods: {
    second(value) {
      let theTime = parseInt(value) // 秒
      let middle = 0 // 分
      if (theTime > 60) {
        middle = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (middle > 60) {
          middle = parseInt(middle % 60)
        }
      }
      let result = '' + parseInt(theTime) + '秒'
      if (middle > 0) {
        result = '' + parseInt(middle) + '分' + result
      }
      return result
    },
    getDetails() {
      this.$http
        .get('/answer/details', {
          params: {
            id: this.id,
          },
        })
        .then((res) => {
          this.form = res.data
          this.form.surveyAnswerNodes.forEach((item) => {
            if (item.tftype === 9) {
              let count = 0
              item.infeedFillBlankText = item.content.replace(
                /_+/gi,
                (match) => {
                  let str = item.fvs[count] ? item.fvs[count].value : ''
                  count++
                  return '<span class="black-line">' + str + '</span>'
                }
              )
              // console.log(this.infeedFillBlankText)
              item.infeedFillBlankText = item.infeedFillBlankText.replace(
                /(\r\n|\n|\r)/gm,
                '</br>'
              )
            }
          })
         console.log(this.form.surveyAnswerNodes)
        })
    },
    back() {
      this.$router.back()
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  padding: 30px 0;
  .content-message {
    padding: 0 10px;
  }
  .content-title {
    font-size: 18px;
    color: #333;
    margin-bottom: 20px;
  }
}
.row {
  padding: 10px;
}
.rowList {
  padding: 10px;
  border-top: 1px solid #dfdfdf;
}
</style>
<style>
.black-line {
  padding: 0 3px;
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/pages/questionnaire/answer/details.vue